'use strict';

var Backbone = require('backbone');

export default Backbone.Model.extend({

  isFull: function () {
    if (!this.has('attendee_limit')) {
      return false;
    }

    var count = parseInt(this.get('attendee_count'));
    var limit = parseInt(this.get('attendee_limit'));

    return count >= limit;
  },

});
